"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentSerializer = void 0;
var models_1 = require("../../models");
var constants_1 = require("../../constants");
/**
 * Serializes assessment
 *
 * @author javier.perez
 */
var AssessmentSerializer = /** @class */ (function () {
    function AssessmentSerializer(assessmentTemplateSerializer, optionSerializer) {
        this.assessmentTemplateSerializer = assessmentTemplateSerializer;
        this.optionSerializer = optionSerializer;
    }
    AssessmentSerializer.prototype.serialize = function (_a) {
        var id = _a.id, assessmentTemplate = _a.assessmentTemplate, settings = _a.settings, status = _a.status, assignedAt = _a.assignedAt, autoLaunch = _a.autoLaunch, finishedAt = _a.finishedAt, bundleId = _a.bundleId, contextId = _a.contextId, endDate = _a.endDate, ownerId = _a.ownerId, startDate = _a.startDate, totalAssigned = _a.totalAssigned, totalSubmitted = _a.totalSubmitted, type = _a.type, usesCustomRubrics = _a.usesCustomRubrics, noStudentSubmissionsFlow = _a.noStudentSubmissionsFlow;
        var owner = ownerId ? new models_1.User({ id: ownerId }) : undefined;
        var assessmentClass = contextId ? new models_1.Class({ id: contextId }) : undefined;
        var serializedAssessmentTemplate = assessmentTemplate
            ? this.assessmentTemplateSerializer.serialize(assessmentTemplate)
            : undefined;
        var serializerSettingOption = settings
            ? this.optionSerializer.serialize(settings)
            : undefined;
        return new models_1.Assessment({
            id: id,
            assessmentTemplate: serializedAssessmentTemplate,
            autoLaunch: autoLaunch,
            settings: serializerSettingOption,
            status: status ? (0, constants_1.getAssessmentStatusFrom)(status) : undefined,
            assignedAt: assignedAt,
            finishedAt: finishedAt,
            bundleId: bundleId,
            assessmentClass: assessmentClass,
            endDate: endDate,
            owner: owner,
            startDate: startDate,
            totalSubmitted: totalSubmitted,
            totalAssigned: totalAssigned,
            type: type ? (0, constants_1.getAssessmentTypeFrom)(type) : undefined,
            usesCustomRubrics: usesCustomRubrics || false,
            noStudentSubmissionsFlow: noStudentSubmissionsFlow,
        });
    };
    return AssessmentSerializer;
}());
exports.AssessmentSerializer = AssessmentSerializer;
